import { messages } from '../../../CommonFunctions/aliases';
import { orderByDependency } from '../../utils';

export const getSortedCalculationRequestBody = (
  session: any,
  currentInfo: any,
  nonAggCalcs: any[],
  setAlert: any,
  setLoading: any,
) => {
  let reqBody: any[] = [];
  const uuid = session.uuid;

  if (nonAggCalcs.length > 0) {
    const index = nonAggCalcs.findIndex((c) => c.uuid === uuid);
    if (index !== -1) {
      nonAggCalcs[index] = { uuid, tableId: session.tableId, ...currentInfo };
    }
    // reqBody.push(...nonAggCalcs.map((c) => [c]));
    nonAggCalcs.forEach((c) => reqBody.push(c));
    // if (index === -1) {
    //   reqBody.push({ uuid, tableId: session.tableId, ...currentInfo });
    // }
  }

  for (const group of reqBody) {
    const res = orderByDependency(group);
    if (res.error) {
      setAlert({ message: messages.formula.cyclicDependency, severity: 'error' });
      setLoading(false);
      return null;
    }
    const newFlows: any = {};
    for (const flow of res.orderedFlows) newFlows[flow] = group.flows[flow];
    group.flows = newFlows;
  }

  return reqBody;
};
